export default [
  {
    title: "menu-intro",
    icon: "infoCircleFilled",
    href: "/intro",
  },
  {
    title: "menu-principles",
    icon: "heartFilled",
    href: "/principles",
  },
  {
    title: "menu-privacybydesign",
    icon: "lockCloseFilled",
    href: "/privacybydesign",
  },
  {
    title: "menu-steps",
    icon: "playFilled",
    href: "/steps",
    children: [
      { href: "/steps/flowchart", title: "menu-flowchart" },
      { href: "/steps/1briefing", title: "menu-1briefing" },
      { href: "/steps/2immersion", title: "menu-2immersion" },
      { href: "/steps/3definition", title: "menu-3definition" },
      { href: "/steps/4ideation", title: "menu-4ideation" },
      { href: "/steps/5prototype", title: "menu-5prototype" },
      { href: "/steps/6validation", title: "menu-6validation" },
      { href: "/steps/7delimitation", title: "menu-7delimitation" },
      { href: "/steps/8refinement", title: "menu-8refinement" },
      { href: "/steps/9sprint", title: "menu-9sprint" },
      { href: "/steps/10release", title: "menu-10release" },
      { href: "/steps/11improvement", title: "menu-11improvement" },
    ],
  },
  {
    title: "menu-methods",
    icon: "gearFilled",
    href: "/methods",
    children: [
      { href: "/methods/align", title: "menu-align" },
      { href: "/methods/contentaudit", title: "menu-contentaudit" },
      { href: "/methods/impactanalysis", title: "menu-impactanalysis" },
      { href: "/methods/benchmarking", title: "menu-benchmarking" },
      { href: "/methods/brainstorming", title: "menu-brainstorming" },
      { href: "/methods/briefing", title: "menu-briefing" },
      { href: "/methods/cpv", title: "menu-cpv" },
      { href: "/methods/cardsorting", title: "menu-cardsorting" },
      { href: "/methods/privacychecklist", title: "menu-privacychecklist" },
      { href: "/methods/competitivaudit", title: "menu-competitivaudit" },
      { href: "/methods/crazy8", title: "menu-crazy8" },
      { href: "/methods/csd", title: "menu-csd" },
      { href: "/methods/acceptancecriteria", title: "menu-acceptancecriteria" },
      { href: "/methods/designsprint", title:"menu-designsprint"},
      { href: "/methods/designstudio", title:"menu-designstudio"},
      { href: "/methods/deskresearch", title: "menu-deskresearch" },
      { href: "/methods/interview", title: "menu-interview" },
      { href: "/methods/hypothesisgeneration", title:"menu-hypothesisgeneration"},
      { href: "/methods/userjourney", title: "menu-userjourney" },
      { href: "/methods/datacollection", title: "menu-datacollection" },
      { href: "/methods/empathymap", title:"menu-empathymap"},
      { href: "/methods/metrics", title: "menu-metrics" },
      { href: "/methods/observation", title: "menu-observation" },
      { href: "/methods/personas", title: "menu-personas" },
      { href: "/methods/survey", title: "menu-survey" },
      { href: "/methods/securityrequirements", title: "menu-securityrequirements" },
      { href: "/methods/tarotcardsoftech", title: "menu-tarotcardsoftech" },
      { href: "/methods/termsofuse", title: "menu-termsofuse" },
      { href: "/methods/alfatest", title: "menu-alfatest" },
      { href: "/methods/usertest", title: "menu-usertest" },
      { href: "/methods/5seconds", title: "menu-5seconds" },
      { href: "/methods/30circles", title: "menu-30circles" },
      { href: "/methods/securitytests", title: "menu-securitytests" },
    ],
  },
  {
    title: "menu-about-bridge",
    icon: "chatFilled",
    href: "/about",
  },
]
